import type { MemberAudienceStatsDto } from "../../../api/memberAudienceStats";
import type { TargetGroup } from "./notificationStore";

export type MemberAudienceUiCounts = {
  all: number;
  active: number;
  new: number;
  vip: number;
  unsigned: number;
  level_normal: number;
  level_premium: number;
  level_director: number;
};

export function buildMemberAudienceUiCounts(
  api: MemberAudienceStatsDto,
  sortedLevelNames: string[],
): MemberAudienceUiCounts {
  const lc = api.levelCounts;
  const n = (name: string) => (name ? (lc[name] ?? 0) : 0);
  const names = sortedLevelNames;
  const normal = n(names[0] ?? "");
  const premium = n(names[1] ?? "");
  const director = n(names[2] ?? "");
  let vip = 0;
  for (let i = 1; i < names.length; i++) vip += n(names[i] ?? "");
  return {
    all: api.totalMembers,
    active: api.activeMembers,
    new: api.newWithin30Days,
    vip,
    unsigned: api.unsignedCount,
    level_normal: normal,
    level_premium: premium,
    level_director: director,
  };
}

export function countForTargetGroup(g: TargetGroup, c: MemberAudienceUiCounts | null): number {
  if (!c) return 0;
  switch (g) {
    case "all":
      return c.all;
    case "active":
      return c.active;
    case "new":
      return c.new;
    case "vip":
      return c.vip;
    case "unsigned":
      return c.unsigned;
    case "level_normal":
      return c.level_normal;
    case "level_premium":
      return c.level_premium;
    case "level_director":
      return c.level_director;
    default:
      return 0;
  }
}
